import Description from './Description'

export enum InputType {
  PERCENTAGE = 'PERCENTAGE',
  SQUARE_METER = 'SQUARE_METER',
  CURRENCY = 'CURRENCY',
}

type ResultOutputProps = {
  label: string
  description?: string
  value: string | number
  isLast?: boolean
}

const ResultOutput: React.FC<ResultOutputProps> = ({ label, description, value, isLast = false }) => {
  return (
    <div className={`flex flex-row gap-5 border-t border-green pt-3 items-center ${isLast && 'border-b'}`}>
      <div className="flex-1">
        <div className="text-black text-right text-xl font-light lg:text-2xl xl:text-6xl whitespace-nowrap">{value}</div>
      </div>
      <div className="flex-1 flex">
        <div className="text-black text-md md:text-md font-light xl:-mb-6">{label}</div>
        <Description text={description} />
      </div>
    </div>
  )
}

export default ResultOutput
